module.exports = __webpack_public_path__ + "media/images/icons/calendar-icon-a99d0ebcc4d18d1a37f0d8f013c00483.svg";